<!-- =========================================================================================
    File Name: Trend.vue
    Description: Price Optimization Trend
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="trend" class="mt-base">
    <!-- <pre>{{test}}</pre> -->
    <div class="vx-row" v-if="false">
      <div class="vx-col w-full md:w-2/3 mb-base">
        <vx-card title="Discount ~ Platform Avg. vs Purchase Avg.">
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1">Weekly discount trend</p>
              </div>
            </div>
            <vue-apex-charts
              type="line"
              height="300"
              :options="discountTrend.chartOptions"
              :series="trendData.series.discount"
            />
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Discount ~ Current Week">
          <template slot="actions">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>

          <div slot="no-body" class="p-6">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1">Purchased Average</p>
              </div>
            </div>
            <vue-apex-charts
              type="radialBar"
              height="240"
              :options="discountCurrent.chartOptions"
              :series="[trendData.data.current.purchase]"
            />
          </div>

          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div
              class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
            >
              <p class="mt-4">Platform Avg.</p>
              <p
                class="mb-4 text-3xl font-semibold"
              >{{(trendData.data.current.platform / 100) | numFormat('0,0%')}}</p>
            </div>
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
              <p class="mt-4">Diff</p>
              <p
                class="mb-4 text-3xl font-semibold"
              >{{(trendData.data.current.diff / 100) | numFormat('0,0%')}}</p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row" v-if="false">
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-base">
        <vx-card title="Rate of Sale">
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="266"
              :options="salesLine.chartOptions"
              :series="trendData.series.sales"
            />
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-base">
        <vx-card :title="'Profit ( '+currency+' )'">
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="266"
              :options="profitLine.chartOptions"
              :series="trendData.series.profit"
            />
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-base">
        <vx-card :title="'Sales ( '+currency+' )'">
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="266"
              :options="revenueLine.chartOptions"
              :series="trendData.series.revenue"
            />
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card title="ROS vs Discount" code-toggler>
          <vue-apex-charts
            ref="swat"
            type="scatter"
            height="500"
            :options="scatterData"
            :series="trendData.series.swat"
          ></vue-apex-charts>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      currency: this.$options.filters.currencySymbol(""),
      selectedUnit: [],
      swatData: [],
      discountTrend: {
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [4, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['01', '05', '09', '13', '17', '21', '26', '31'],
            axisBorder: {
              show: false
            },
            title: {
              text: "Week",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
              }
            },
            title: {
              text: "Discount %",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      discountCurrent: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 110,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77%"
              },
              track: {
                background: "#bfc5cc",
                strokeWidth: "50%"
              },
              dataLabels: {
                name: {
                  show: false
                },
                value: {
                  offsetY: 18,
                  color: "#99a2ac",
                  fontSize: "4rem"
                }
              }
            }
          },
          colors: ["#00db89"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#00b5b5"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: "round"
          },
          chart: {
            sparkline: {
              enabled: true
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          }
        }
      },
      salesLine: {
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            width: 4
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            },
            title: {
              text: "Week",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
              }
            },
            title: {
              text: "Qty. Sold ( Units )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      profitLine: {
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            width: 4
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            },
            title: {
              text: "Week",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
              }
            },
            title: {
              text: "Profit ( "+this.$options.filters.currencySymbol("") +" )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      revenueLine: {
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            width: 4
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            },
            title: {
              text: "Week",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
              }
            },
            title: {
              text: "Sales ( "+this.$options.filters.currencySymbol("") +" )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      scatterChart: {
        chartOptions: {
          colors: [themeColors[0], themeColors[4]],
          // annotations: {
          //   position: "front",
          //   yaxis: [
          //     {
          //       y: 0.55,
          //       borderColor: "#2698FF",
          //       label: {
          //         borderColor: "#2698FF",
          //         style: {
          //           color: "#fff",
          //           background: "#2698FF"
          //         },
          //         text: "Discount Sensitivity"
          //       }
          //     }
          //   ],
          //   xaxis: [
          //     {
          //       // in a datetime series, the x value should be a timestamp, just like it is generated below
          //       x: 0.48,
          //       strokeDashArray: 0,
          //       borderColor: "#2698FF",
          //       label: {
          //         borderColor: "#2698FF",
          //         style: {
          //           color: "#fff",
          //           background: "#2698FF"
          //         },
          //         text: "Rate of Sale"
          //       }
          //     }
          //   ]
          // },
          chart: {
            zoom: {
              enabled: true,
              type: "xy"
            },
            toolbar: {
              show: true,
              autoSelected: "zoom"
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            } 
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            type: "solid"
          },
          markers: {
            size: [10]
          },
          grid: {
            show: false
          },
          xaxis: {
            // offsetY: -200,
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false,
              color: "#008FFB"
            },
            labels: {
              show: false,
              style: {
                color: "#008FFB"
              }
            },
            title: {
              show: false,
              // text: "Inventory",
              style: {
                color: "#008FFB"
              }
            },
            tickAmount: 8
          },
          yaxis: {
            opposite: true,
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false,
              color: "#008FFB"
            },
            labels: {
              show: false,
              style: {
                color: "#008FFB"
              }
            },
            title: {
              show: false,
              // text: "Rate of Sale / Week",
              style: {
                color: "#008FFB"
              }
            }
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              function colorCode(type) {
                if (type === "OOS") {
                  return "color:red; font-size:30px";
                } else if (type === "Under Stock") {
                  return "color:orange;";
                } else if (type === "Over Stock") {
                  return "color:orange; font-size:30px";
                } else {
                  return "color:green";
                }
              }

              return (
                '<div class="custom-tooltip">' +
                '<div class="group1">' +
                "<div><span>" +
                w.config.series[0].categories[dataPointIndex] +
                "</span> <br />" +
                "</div>" +
                // '<div class="group1">Expected Sale per Week: ' +
                // '<strong>' + series[0][dataPointIndex] + '</strong>' +
                // '</div>' +
                // '<div class="group1">Stock In Hand: ' +
                // '<strong>' + series[1][dataPointIndex] + '</strong>' +
                // '</div>' +
                "</div>" +
                // '<div class="group">' +
                // '<h5 style="' + colorCode(w.config.series[2].categories[dataPointIndex]) + '">' + w.config.series[2].categories[dataPointIndex] + '</h5>' +
                // '</div>' +
                "</div>" +
                "</div>"
              );

              // return w.config.series[0].categories[dataPointIndex];
            }
          }
        },
        series: []
      },
      test: null
    };
  },
  watch: {},
  computed: {
    trendData() {
      let trendData = {
        data: {
          current: {
            purchase: 0,
            platform: 0,
            diff: 0
          }
        },
        series: {
          discount: [],
          sales: [],
          profit: [],
          revenue: [],
          swat: [],
          swatAxix: {
            rosMax: 0.0,
            rosMin: 0.0,
            disMax: 0.0,
            disMin: 0.0
          }
        }
      };

      let selectedUnit = this.artefact.tags && this.artefact.tags.length > 1 ? this.artefact.tags[1].tag : "";
      let minWeek = Math.min.apply(Math, this.artefact.res.trend.data.overview.map(function(o) { 
                    return o.sale_week;  
                })); 
      
      let maxWeek = Math.max.apply(Math, this.artefact.res.trend.data.overview.map(function(o) { 
                    return o.sale_week;  
                }));



      let selectedUnitData = this.fillGap(this.artefact.res.trend.data.overview.filter(item => item.product_category.toLowerCase() === selectedUnit.toLowerCase()), minWeek, maxWeek, selectedUnit);

      this.selectedUnit = selectedUnitData;

      let currWeekData = selectedUnitData.filter(item => item.sale_week === maxWeek);

      let platformDiscount = {
        name: 'Platform Avg',
        data: selectedUnitData.map(o => o.platform_discount)
      };
      let purchaseDiscount = {
        name: 'Purchased Avg',
        data: selectedUnitData.map(o => o.purchase_discount)
      };
      
      let saleTrend = {
        name: 'Sales',
        data: selectedUnitData.map(o => o.quantity_sold)
      };

      let profitTrend = {
        name: 'Profit',
        data: selectedUnitData.map(o => o.total_profit_made)
      };

      let revenueTrend = {
        name: '$ Sales',
        data: selectedUnitData.map(o => o.total_revenue)
      };

      let selectedRecommendData = this.artefact.res.recommend.data.filter(item => item.product_category.toLowerCase() === selectedUnit.toLowerCase());
      let selectedUnitDataIntercept = this.artefact.res.trend.data.swat.intercept.filter(item => item.Group.toLowerCase() === selectedUnit.toLowerCase());
      let ros_intercept = selectedUnitDataIntercept && selectedUnitDataIntercept.length > 0 ? selectedUnitDataIntercept[0].ros_intercept : 0.55;
      let dis_intercept = selectedUnitDataIntercept && selectedUnitDataIntercept.length > 0 ? selectedUnitDataIntercept[0].dis_intercept : 0.48;
      let min_disc_sense = dis_intercept*(-1);
      let max_disc_sense = dis_intercept*1;
      let discountedData = selectedRecommendData.filter(o => o.recommended_discount_percent > 0 && o.recommended_discount_percent > min_disc_sense && o.recommended_discount_percent < max_disc_sense);
      let noDiscountData = selectedRecommendData.filter(o => o.recommended_discount_percent === 0 && o.recommended_discount_percent > min_disc_sense && o.recommended_discount_percent < max_disc_sense);


      // let minRecommed = Math.min.apply(Math, discountedData.map(function(o) { 
      //               return o.axis_discount_sensitivity;  
      //           })); 
      
      // let maxRecommed = Math.max.apply(Math, discountedData.map(function(o) { 
      //               return o.axis_discount_sensitivity;  
      //           }));
      // this.test = 
      //   'dis_intercept:'+ dis_intercept+', '+
      //   'min_disc_sense:'+ min_disc_sense+', '+
      //   'max_disc_sense:'+ max_disc_sense+', '+
      //   'minRecommed:'+ minRecommed+', '+
      //   'maxRecommed:'+ maxRecommed

      let swat_all_ros_axis = selectedRecommendData.map(o => o.axis_rate_of_sale);
      let swat_all_dis_axis = selectedRecommendData.map(o => o.axis_discount_sensitivity);

      let swat_max_ros = Math.max(...swat_all_ros_axis);
      let swat_min_ros = Math.min(...swat_all_ros_axis);
      let swat_max_dis = Math.max(...swat_all_dis_axis);
      let swat_min_dis = Math.min(...swat_all_dis_axis);

      let swat = [{
        name: "Latest Transaction without Discount",
        data: noDiscountData.map(o => [Math.round(o.axis_discount_sensitivity), Math.round(o.axis_rate_of_sale)]),
        categories: noDiscountData.map(o => (o.sku_id +' - ' + o.short_description + ' ( ' +o.brand +' - '+ o.product_category +' )')),
      }, {
        name: "Latest Transaction with Discount",
        data: discountedData.map(o => [Math.round(o.axis_discount_sensitivity), Math.round(o.axis_rate_of_sale)]),
        categories: discountedData.map(o => (o.sku_id +' - ' + o.short_description + ' ( ' +o.brand +' - '+ o.product_category +' )')),
      }];


      trendData.data.current.platform = currWeekData[0] ? currWeekData[0].platform_discount : 0;
      trendData.data.current.purchase = currWeekData[0] ? currWeekData[0].purchase_discount : 0;
      trendData.data.current.diff = Number(currWeekData[0] ? currWeekData[0].platform_discount : 0) - Number(currWeekData[0] ? currWeekData[0].purchase_discount : 0);
      trendData.series.discount.push(platformDiscount);
      trendData.series.discount.push(purchaseDiscount);
      trendData.series.sales.push(saleTrend);
      trendData.series.profit.push(profitTrend);
      trendData.series.revenue.push(revenueTrend);
      trendData.series.swat = swat;
      trendData.series.swatAxix.rosMax = swat_max_ros;
      trendData.series.swatAxix.rosMin = swat_min_ros;
      trendData.series.swatAxix.disMax = swat_max_dis;
      trendData.series.swatAxix.disMin = swat_min_dis;

      return trendData;
    },

    // buildDataSeries() {
    //   this.artefact.res.swat.filter(item => {
    //     if (item.sold_flag > 0) {
    //       series1.data.push([item.ros, item.disc_sense]);
    //       series1.categories.push(
    //         item.sku_id +
    //           " - " +
    //           item.desc +
    //           " ( " +
    //           item.brand +
    //           " - " +
    //           item.category +
    //           " )"
    //       );
    //     } else {
    //       series0.data.push([item.ros, item.disc_sense]);
    //       series0.categories.push(
    //         item.sku_id +
    //           " - " +
    //           item.desc +
    //           " ( " +
    //           item.brand +
    //           " - " +
    //           item.category +
    //           " )"
    //       );
    //     }
    //   });

    //   dataSeries.push(series0);
    //   dataSeries.push(series1);
    //   return dataSeries;
    // },

    scatterData() {
      let selectedUnit = this.artefact.tags && this.artefact.tags.length > 1 ? this.artefact.tags[1].tag : "";
      let selectedUnitData = this.artefact.res.trend.data.swat.intercept.filter(item => item.Group.toLowerCase() === selectedUnit.toLowerCase());

      this.scatterChart.chartOptions = {
        ...this.scatterChart.chartOptions,
        ...{

      // let chartOptions = {
      //     colors: themeColors,
          annotations: {
            position: "front",
            yaxis: [
              {
                // y: (selectedUnitData && selectedUnitData.length > 0 ? selectedUnitData[0].ros_intercept : 0.55),//+(this.trendData.series.swatAxix.rosMin*-1),
                y:0,
                borderColor: "#2698FF",
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  text: "Discount Sensitivity"
                }
              }
            ],
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                // x: (selectedUnitData && selectedUnitData.length > 0 ? selectedUnitData[0].dis_intercept : 0.48)+(this.trendData.series.swatAxix.disMin*-1),
                x: 600,
                strokeDashArray: 0,
                borderColor: "#2698FF",
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  text: "Rate of Sale"
                }
              }
            ]
          },
          chart: {
            zoom: {
              enabled: true,
              type: "xy"
            },
            toolbar: {
              show: true,
              autoSelected: "zoom"
            }
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            type: "solid"
          },
          markers: {
            size: [6]
          },
          grid: {
            show: false
          },
          xaxis: {
            // offsetY: -200,
            min: (this.trendData.series.swatAxix.disMax*-1),
            max: this.trendData.series.swatAxix.disMax,
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false,
              color: "#008FFB"
            },
            labels: {
              show: false,
              style: {
                color: "#008FFB"
              }
            },
            title: {
              show: false,
              // text: "Inventory",
              style: {
                color: "#008FFB"
              }
            },
            tickAmount: 8
          },
          yaxis: {
            opposite: true,
            min: (this.trendData.series.swatAxix.rosMax*-1),
            max: this.trendData.series.swatAxix.rosMax,
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false,
              color: "#008FFB"
            },
            labels: {
              show: false,
              style: {
                color: "#008FFB"
              }
            },
            title: {
              show: false,
              // text: "Rate of Sale / Week",
              style: {
                color: "#008FFB"
              }
            }
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              function colorCode(type) {
                if (type === "OOS") {
                  return "color:red; font-size:30px";
                } else if (type === "Under Stock") {
                  return "color:orange;";
                } else if (type === "Over Stock") {
                  return "color:orange; font-size:30px";
                } else {
                  return "color:green";
                }
              }

              return (
                '<div class="custom-tooltip">' +
                '<div class="group1">' +
                "<div><span>" +
                w.config.series[0].categories[dataPointIndex] +
                "</span> <br />" +
                "</div>" +
                // '<div class="group1">Expected Sale per Week: ' +
                // '<strong>' + series[0][dataPointIndex] + '</strong>' +
                // '</div>' +
                // '<div class="group1">Stock In Hand: ' +
                // '<strong>' + series[1][dataPointIndex] + '</strong>' +
                // '</div>' +
                "</div>" +
                // '<div class="group">' +
                // '<h5 style="' + colorCode(w.config.series[2].categories[dataPointIndex]) + '">' + w.config.series[2].categories[dataPointIndex] + '</h5>' +
                // '</div>' +
                "</div>" +
                "</div>"
              );

              // return w.config.series[0].categories[dataPointIndex];
            }
          }
        }
      };

      return this.scatterChart.chartOptions;

    }    
  },
  methods: {
    fillGap(data, start, end, type) {
      let correctedData = [];
      for(let i= start; i <= end; i++) {
        let dataFound = false;
        for(let dataCount = 0; dataCount < data.length; dataCount++) {
          if(data[dataCount] && data[dataCount].sale_week && data[dataCount].sale_week === i) {
            correctedData.push(data[dataCount]);
            dataFound = true;
            break;
          }
        }
        if(!dataFound) {
          let dummyData = {
            "sale_week": i,
            "sale_year": 2019,
            "product_category": type,
            "platform_discount": 0,
            "purchase_discount": 0,
            "quantity_sold": 0,
            "total_revenue": 0,
            "total_profit_made": 0
          };

          correctedData.push(dummyData);
        }
      }

      return correctedData;
    },
  },
  mounted() {},
  components: {
    VueApexCharts,
    StatisticsCardLine
  }
};
</script>

<style lang="scss">
#trend {
}
</style>
